// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4163 ? "37e0aedc" : chunkId) + "." + {"4114":"22552aa8865e832f","4163":"60c57e2f4e10ae68"}[chunkId] + ".js";
};